import type * as React from 'react';

import { get2DigitsDay, get2DigitsMonth } from '../Intl';

/**
 * Format a date as a calendar
 */
export function DatePrettyCalendary(props: {
    value: Date;
    className?: string;
}): React.ReactElement {
    const { value, className } = props;
    return <span className={className}>{prettyDate(value)}</span>;
}

function prettyDate(date: Date): string {
    const day = get2DigitsDay(date);
    const month = get2DigitsMonth(date);
    const year = date.getFullYear();

    return [year, month, day].join('-');
}
